import styled from "styled-components";
import { apolloLineHeightHeading3, apolloSpaceInline1HalfX, apolloSpaceInline1X, apolloSpaceInset1HalfX, apolloSpaceInset3X, apolloSpaceStackHalfX, } from "@nexthink/apollo-tokens";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
import Box from "../box/Box";
import Flex from "../box/Flex";
import Text from "../text/Text";
import { H3 } from "../heading/Heading";
import { ROUND_BUTTON_ICON_SIZE } from "../button-icon/ButtonIcon.style";
const collapsibleButtonPaddingRight = apolloSpaceInline1X;
const collapsibleSubtitleOffset = ROUND_BUTTON_ICON_SIZE + getValueFromPixelString(collapsibleButtonPaddingRight);
const headingHeightRem = apolloLineHeightHeading3;
export const StyledHeader = styled(Box).withConfig({ displayName: "StyledHeader_APC-7281-productShell", componentId: "sc-ok2zxm" })({
    margin: `0 ${apolloSpaceInset3X}`,
});
export const StyledHeaderTop = styled(Flex).withConfig({ displayName: "StyledHeaderTop_APC-7281-productShell", componentId: "sc-rnxqly" })(({ theme }) => ({
    alignItems: "flex-start",
    flex: "0 0 auto",
    position: "relative",
    zIndex: 0,
    "&::after": {
        borderTop: `1px solid ${theme.colors.apolloColorStrokeSeparator}`,
        boxSizing: "border-box",
        content: "''",
        left: 0,
        position: "absolute",
        top: `calc(${headingHeightRem} / 2)`,
        width: "100%",
        zIndex: -1,
    },
}));
export const StyledButtonCollapse = styled(Box).withConfig({ displayName: "StyledButtonCollapse_APC-7281-productShell", componentId: "sc-gjf3gn" })(({ theme }) => ({
    marginTop: `calc((${headingHeightRem} - ${ROUND_BUTTON_ICON_SIZE}px) / 2)`,
    paddingRight: collapsibleButtonPaddingRight,
    background: theme.colors.apolloColorBackgroundContainer,
}));
export const StyledHeadingSpacer = styled.div.withConfig({ displayName: "StyledHeadingSpacer_APC-7281-productShell", componentId: "sc-1fpzbdp" })(({ theme }) => ({
    paddingRight: apolloSpaceInline1HalfX,
    background: theme.colors.apolloColorBackgroundContainer,
    overflow: "hidden",
}));
export const StyledHeadingText = styled(H3).withConfig({ displayName: "StyledHeadingText_APC-7281-productShell", componentId: "sc-vat451" })(({ isCollapsible }) => (Object.assign({ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, (isCollapsible && { cursor: "pointer" }))));
export const StyledHeadingComponentContainer = styled(Flex).withConfig({ displayName: "StyledHeadingComponentContainer_APC-7281-productShell", componentId: "sc-1c5ad43" })({
    alignItems: "center",
});
export const StyledExtra = styled.div.withConfig({ displayName: "StyledExtra_APC-7281-productShell", componentId: "sc-r65w1p" })(({ theme }) => ({
    background: theme.colors.apolloColorBackgroundContainer,
    marginLeft: "auto",
    paddingLeft: apolloSpaceInset1HalfX,
}));
export const StyledSubtitle = styled(Text).withConfig({ displayName: "StyledSubtitle_APC-7281-productShell", componentId: "sc-sk2x31" })(({ theme, isCollapsible }) => (Object.assign({ display: "block", marginTop: apolloSpaceStackHalfX, color: theme.colors.apolloColorTextSecondary, overflow: "hidden", textOverflow: "ellipsis" }, (isCollapsible && { marginLeft: collapsibleSubtitleOffset }))));
//# sourceMappingURL=ContainerHeader.style.js.map